import * as Sentry from '@sentry/react';

import { isDev } from '~/dev/utils/isDev';

type SidebarNavPreferenceAction = 'opt_in' | 'opt_out';

const METRIC_NAMES: Record<SidebarNavPreferenceAction, string> = {
  opt_in: 'ui.sidebar_nav.opt_in',
  opt_out: 'ui.sidebar_nav.opt_out',
};

export const recordSidebarNavPreferenceMetric = (
  action: SidebarNavPreferenceAction,
) => {
  if (isDev) {
    console.info(`[sidebar-nav metric] ${action}`);
    return;
  }

  Sentry.startInactiveSpan({
    name: METRIC_NAMES[action],
    op: 'metric.counter',
    attributes: {
      'sentry.op': 'metric.counter',
      'sentry.origin': 'manual.react.metrics',
      value: 1,
      metric_type: 'custom_counter',
      sidebar_nav_action: action,
    },
  }).end();
};
